import gql from 'graphql-tag';

export class SharedFragment {
    static file = gql`
        fragment file on FichierModel {
            IdFile
            Extension
            Filename
            Token
            Url
        }`;
    static folders = gql`
        fragment folders on GEDListeAlbumsGEDModel {
            ListeAlbums {
                PortailAlbumDTO {
                    Id
                    Libelle
                    CeDelegation {
                        Id
                    }
                    ListeDocumentsToSave {
                        FichierCompletModel {
                            IdFile
                            Url
                            Filename
                            StatutCode
                            StatutLibelle
                        }
                    }
                    Statut {
                        Id
                        Code
                        Libelle
                    }
                }
            }
        }`;
    static beneficiaryAttachment = gql`
        fragment beneficiaryAttachment on PieceJustificativeBenefModel {
            MustValidate
            MyGuid
            Status
            CodePJ
            CodeTypePJ
            DateEnvoi
            DateReception
            DescriptionPJ
            Fichier {
                MustValidate
                MyGuid
                Status
                CategCode
                Extension
                FileBytes
                Filename
                IdFile
                IdFileAliznet
                IsFichierClient
                LibelleLien
                RemarqueLien
                Taille
                Token
                TypeFichierLibelle
                Url
            }
            IdAyantDroit
            IdBenef
            IdFormule
            IdPJBenef
            IdPJDossier
            IdPieceJustificative
            IdRib
            IsDeleted
            IsEnvoyee
            IsObligActivite
            IsPJBenef
            IsRecue
            IsUpdated
            IsValide
            LibTypePJ
            LibellePJ
            NomFichier
            OrdreTypePJ
            PrenomBenefAD
            RemarquePriveePJ
            RemarquePublique
            RemarquePubliquePJ
            RibLibelle
            RibLibelleLight
            StatutPJEnum
        }`;
    static address = gql`
        fragment address on AdresseDTO {
            IsCloture
            Ligne1
            Ligne2
            Ligne3
            Ligne4
            Ville {
                Libelle
                CodePostal
                Pays {
                    Libelle
                }
            }
        }`;
}
